import { create } from "zustand";

type genderStore = {
  gender: "men" | "women";
  setGender: (gender: "men" | "women") => void;
};

const genderStore = (set: any): genderStore => ({
  gender: "men",
  setGender: (gender) => set({ gender }),
});

const useGenderStore = create(genderStore);

export default useGenderStore;
